export function daterangePicker() {
    $('input[data-tag="daterange"]').daterangepicker({
        'opens': 'left',
        'locale': {
            'format': 'MMM D YYYY'
        }
    }, function (start, end, label) {
        $('input[name="start"]').val(start.format('YYYYMMDD'));
        $('input[name="end"]').val(end.format('YYYYMMDD'));
    });
    $('#date3m').click(function () {
        $('input[name="start"]').val(moment().format('YYYYMMDD'));
        $('input[name="end"]').val(moment().add(3, 'M').format('YYYYMMDD'));
    });
    $('#date6m').click(function () {
        $('input[name="start"]').val(moment().format('YYYYMMDD'));
        $('input[name="end"]').val(moment().add(6, 'M').format('YYYYMMDD'));
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/daterangePicker.js